export default {
    path : "warehouse-carrier-all",
    name : "warehouse-carrier-all",
    meta : {
        title : "全部载体"
    },
    component: () => import('@/pages/warehouse/allCarrier/Index'),
    redirect: {
        name : "warehouse-carrier-all-whole"
    },
    children: [
        {
            path: 'all',
            name: 'warehouse-carrier-all-whole',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'warehouse-carrier-all-recent',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'warehouse-carrier-all-atme',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'warehouse-carrier-all-meat',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'warehouse-carrier-all-reply',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'warehouse-carrier-all-search',
            meta: {
                title: '仓库载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path : 'detail/:id',
            name : 'warehouse-carrier-all-detail',
            metal: {
                title : '项目详细信息',
            },
            component: () => import('@/pages/carrierCommon/Detail'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/warehouse/allcarrier/index.js